<script setup lang="ts">
import type { KjdsDetailData } from '@/types/appTypes'

const route = useRoute()
const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeArticleDetail = useStoreArticleDetail()
const storeArticleList = useStoreArticleList()
const kjdsPageConfig = storeIndex.getPageConfig()

const pageData: KjdsDetailData = {
  article: null,
  objects: null,
  eyeCatch: null,
  tags: null,
}

definePageMeta({
  // app.config.tsでparams.articleが定義されいるか
  validate: (route) => {
    if (route.params.article) {
      const kjdsConfig = useAppConfig().kijidas
      const kjdsPageConfig: KjdsPageConfig = kjdsConfig.page[route.params.article as string]
      if (kjdsPageConfig?.detail) {
        return true
      }
    }
    console.warn('##KJDS pages/[article]/[slug]: params.article not config', route.params.article)
    return false
  },
})

//  previewは noindex をつける
if ((route.name as string).includes('preview')) {
  useHead({
    meta: [{
      name: 'robots',
      content: 'noindex',
    }],
  })
}

const initPage = async () => {
  let articleSlugOrId: string | number = ''
  if (route.params.slug) {
    articleSlugOrId = route.params.slug as string
  } else if (route.params.id) {
    // previewモードでidが指定されている
    articleSlugOrId = app.$anyToInteger(route.params.id, 0)
  }
  const fetchDetailOptions: KjdsFetchDetailOptions = {
    fetchParams: {
      articleTypeSlug: kjdsPageConfig.articleTypeSlug,
      articleSlugOrId,
    },
  }
  const [resSite, resMaster, resDetail, resTags] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleDetail.fetchDetail(fetchDetailOptions),
    storeArticleList.fetchTags(kjdsPageConfig.articleTypeSlug),
  ])

  if (resDetail?.code === 404000) {
    throw createError({ statusCode: 404 })
    return
  }
  pageData.article = resDetail.data.article
  pageData.objects = resDetail.data.article_objects
  pageData.eyeCatch = storeIndex.getImgInfoByEyeCatch(resDetail.data.article.eye_catch_image_object)
  pageData.tags = resTags.data
}
await initPage()
</script>

<template>
  <NuxtLayout
    v-bind:name="kjdsPageConfig.detail.layout"
  >
    <component
      v-bind:is="kjdsPageConfig.detail.component"
      v-bind:kjds-page-config="kjdsPageConfig"
      v-bind:kjds-detail-data="pageData"
    />
  </NuxtLayout>
</template>
